<!-- src/app/task/task.component.html -->
<div class="flex-col gap-y-2 m-0 bg-purple-50 p-4">
  <app-breadcrumb [breadcrumbs]="breadcrumbs"></app-breadcrumb>
  <app-blanket>
    <section class="bl-header pb-2 mb-2 flex space-x-6 justify-content-between p-6">
      <h2 class="flex-grow-1 m-0">
        Task Management
      </h2>
      <div class="flex items-center space-x-4">
        <div class="relative">
          <label for="name" class="absolute -top-2 left-2 inline-block rounded-lg bg-white px-1 text-xs font-medium text-gray-900">Search</label>
          <input
            (keyup)="applyFilter($event)"
            type="text"
            class="block w-56 rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
            placeholder="Search task here">
        </div>
        <div class="relative">
          <label for="project" class="absolute -top-2 left-2 inline-block rounded-lg bg-white px-1 text-xs font-medium text-gray-900">Project</label>
          <div class="w-56">
            <mat-select (selectionChange)="applyProjectFilter($event.value)" class="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 border outline outline-1 -outline-offset-1 outline-gray-300 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6">
              <mat-option value="">All</mat-option>
              <mat-option *ngFor="let project of projects" [value]="project.id">{{ project.name }}</mat-option>
            </mat-select>
          </div>
        </div>
        <div class="relative">
          <label  for="status" class="absolute -top-2 left-2 inline-block rounded-lg bg-white px-1 text-xs font-medium text-gray-900">Status</label>
          <div class="w-56">
            <mat-select #statusFilter (selectionChange)="applyStatusFilter($event.value)" class="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 border outline outline-1 -outline-offset-1 outline-gray-300 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6" [value]="2">
              <mat-option value="">All</mat-option>
              <mat-option *ngFor="let status of statusParams" [value]="status.value">{{ status.label }}</mat-option>
            </mat-select>
          </div>
        </div>
      </div>
      <div class="flex items-center">
        <app-button-ui size="small" (click)="openNewDialog()">
          New Task
        </app-button-ui>
      </div>
    </section>
    <div class="flex-grow-1 p-6">
      <table mat-table matSort [dataSource]="dataSource" class="w-100">
        <!-- Display taskNumber Column -->
        <ng-container matColumnDef="taskNumber">
          <th width="150" mat-header-cell *matHeaderCellDef> # </th>
          <td class="text-gray-800 font-bold" mat-cell *matCellDef="let element"> {{element.taskNumber}} </td>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="name">
          <th width="450" mat-header-cell mat-sort-header *matHeaderCellDef> Name </th>
          <td class="p-2" mat-cell *matCellDef="let element" (dblclick)="editCell(element, 'name')">
            <input class="p-2 border rounded-md w-full" *ngIf="isEditing(element, 'name')" [(ngModel)]="element.name" (blur)="saveEdit(element, 'name')" />
            <a [routerLink]="['/task/detail', element.id]" *ngIf="!isEditing(element, 'name')">{{element.name}}</a>
            <div class="flex items-center space-x-2 mt-1 text-gray-400 text-xs">
              <img [src]="getProjectImage(element.project)" alt="{{element.name}}" class="w-6 h-6 object-cover rounded-full" />
              <span *ngIf="!isEditing(element, 'project')">{{ getProjectName(element.project) }}</span>
            </div>
          </td>
        </ng-container>

        <!-- Status Column -->
        <ng-container matColumnDef="status">
          <th class="w-28" mat-header-cell mat-sort-header *matHeaderCellDef> Status </th>
          <td class="pe-2" mat-cell *matCellDef="let element" (dblclick)="editCell(element, 'status')" >
            <mat-select
              class="p-1 border rounded-md"
              *ngIf="isEditing(element, 'status')"
              [(ngModel)]="element.status"
              (selectionChange)="saveEdit(element, 'status')"
            >
              <mat-option value=1>Not Start</mat-option>
              <mat-option value=2>On Going</mat-option>
              <mat-option value=3>Completed</mat-option>
              <mat-option value=4>On Hold</mat-option>
              <mat-option value=5>Cancelled</mat-option>
            </mat-select>
            <span *ngIf="!isEditing(element, 'status')"
                  class="px-2 py-1 rounded-md inline-block"
                  [ngClass]="element.status | statusColor">
              {{element.status | status}}
            </span>
          </td>
        </ng-container>

        <!-- Progress Column -->
        <ng-container matColumnDef="progress">
          <th class="w-32" mat-header-cell mat-sort-header *matHeaderCellDef> Progress </th>
          <td class="pe-2" mat-cell *matCellDef="let element">
            <div class="flex items-center space-x-2">
              <mat-progress-bar
                mode="determinate"
                [value]="element.percentageCompletion"
                [color]="getProgressColor(element.percentageCompletion)"
                class="flex-grow-1">
              </mat-progress-bar>
              <span class="text-sm text-gray-600">{{element.percentageCompletion}}%</span>
            </div>
          </td>
        </ng-container>

        <!-- Dates Column -->
        <ng-container matColumnDef="dates">
          <th class="px-4" mat-header-cell mat-sort-header *matHeaderCellDef> Dates </th>
          <td mat-cell *matCellDef="let element">
            <div class="flex items-center space-x-2 px-4">
              <span>{{element.startDate | date:'MMM d'}}</span>
              <span class="text-gray-400">-</span>
              <span>{{element.endDate | date:'MMM d'}}</span>
            </div>
          </td>
        </ng-container>

        <!-- Number of Days Column -->
        <ng-container matColumnDef="numberOfDays">
          <th mat-header-cell mat-sort-header *matHeaderCellDef> Days </th>
          <td class="text-gray-300" mat-cell *matCellDef="let element"> {{element.numberOfDays}} </td>
        </ng-container>

        <!-- LOE Column -->
        <ng-container matColumnDef="loe">
          <th mat-header-cell mat-sort-header *matHeaderCellDef> LOE </th>
          <td mat-cell *matCellDef="let element"> {{element.loe}} </td>
        </ng-container>

        <!-- Action Column -->
        <ng-container matColumnDef="action">
          <th class="w-32" mat-header-cell *matHeaderCellDef> Action </th>
          <td mat-cell *matCellDef="let element">
            <div class="action-buttons" *ngIf="selectedTask?.id === element.id">
              <button mat-icon-button color="primary" (click)="openEditDialog(element)">
                <mat-icon>edit</mat-icon>
              </button>
              <button mat-icon-button color="warn" (click)="openDeleteDialog(element)">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="selectTask(row)"></tr>
      </table>

      <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]" aria-label="Select page of tasks"></mat-paginator>
    </div>
  </app-blanket>
</div>
